import React from 'react';
import { trackStateChanged } from '../../factories/analytics/analytics.service';

class Analytics extends React.Component {
  componentDidMount() {
    trackStateChanged('', this.props.location.pathname);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.location !== this.props.location) {
      trackStateChanged(
        prevProps.location.pathname,
        this.props.location.pathname
      );
    }
  }

  render() {
    return null;
  }
}

export default Analytics;
